import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ArrowLeft, Check } from "lucide-react";

const BookingStepReview = ({ formData, submitting, onBack, onSubmit }) => {
  const { t } = useTranslation();

  return (
    <Card className="bg-white border-0 shadow-lg" data-testid="step-3-card">
      <CardHeader>
        <CardTitle className="text-2xl text-[#3D405B] font-['Playfair_Display']">
          {t("booking.step3.title")}
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="bg-[#F4F1DE] rounded-xl p-6 space-y-4">
          <h4 className="font-semibold text-[#3D405B]">
            {t("booking.step3.eventDetails")}
          </h4>
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div>
              <span className="text-[#6B705C]">{t("booking.step3.eventType")}</span>
              <p className="font-medium text-[#3D405B]">{formData.event_type}</p>
            </div>
            <div>
              <span className="text-[#6B705C]">{t("booking.step3.date")}</span>
              <p className="font-medium text-[#3D405B]">{formData.event_date}</p>
            </div>
            <div>
              <span className="text-[#6B705C]">{t("booking.step3.guests")}</span>
              <p className="font-medium text-[#3D405B]">
                {formData.guest_count} {t("booking.step3.people")}
              </p>
            </div>
          </div>
        </div>

        <div className="bg-[#F4F1DE] rounded-xl p-6 space-y-4">
          <h4 className="font-semibold text-[#3D405B]">
            {t("booking.step3.contactInfo")}
          </h4>
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div>
              <span className="text-[#6B705C]">{t("booking.step3.name")}</span>
              <p className="font-medium text-[#3D405B]">{formData.customer_name}</p>
            </div>
            <div>
              <span className="text-[#6B705C]">{t("booking.step3.email")}</span>
              <p className="font-medium text-[#3D405B]">{formData.customer_email}</p>
            </div>
            <div>
              <span className="text-[#6B705C]">{t("booking.step3.phone")}</span>
              <p className="font-medium text-[#3D405B]">{formData.customer_phone}</p>
            </div>
            <div>
              <span className="text-[#6B705C]">{t("booking.step3.venue")}</span>
              <p className="font-medium text-[#3D405B]">{formData.venue_address}</p>
            </div>
          </div>
          {formData.special_requests && (
            <div>
              <span className="text-[#6B705C] text-sm">
                {t("booking.step3.specialRequests")}
              </span>
              <p className="text-sm text-[#3D405B]">{formData.special_requests}</p>
            </div>
          )}
        </div>

        <div className="flex gap-4">
          <Button
            variant="outline"
            onClick={onBack}
            data-testid="back-to-contact-btn"
            className="flex-1 py-6 rounded-full"
          >
            <ArrowLeft className="mr-2 w-5 h-5" />
            {t("booking.step3.backBtn")}
          </Button>
          <Button
            onClick={onSubmit}
            disabled={submitting}
            data-testid="submit-booking-btn"
            className="flex-1 bg-[#E07A5F] hover:bg-[#D0694E] text-white py-6 rounded-full"
          >
            {submitting ? (
              <>
                <div className="spinner w-5 h-5 mr-2" />
                {t("booking.step3.submitting")}
              </>
            ) : (
              <>
                <Check className="mr-2 w-5 h-5" />
                {t("booking.step3.confirmBtn")}
              </>
            )}
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default BookingStepReview;
